import _ from 'lodash';

import { FEE_TYPES_ACTION_TYPE } from 'store/system/actions';

import { getMergedFeeTypeWithOverride } from './feeTypes.reducer.utils';

const initialState = {};

const feeTypesReducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case FEE_TYPES_ACTION_TYPE.GET_FEE_TYPES:
      return { ...(payload || initialState) };

    case FEE_TYPES_ACTION_TYPE.CREATE_FEE_TYPE:
    case FEE_TYPES_ACTION_TYPE.EDIT_FEE_TYPE:
      return { ...state, [meta.feeTypeId]: payload };

    case FEE_TYPES_ACTION_TYPE.DELETE_FEE_TYPE:
      return _.omit(state, meta.feeTypeId);

    case FEE_TYPES_ACTION_TYPE.CREATE_OR_UPDATE_OVERRIDE: {
      const existingFeeType = state[meta.feeTypeId];

      if (!existingFeeType) {
        return state;
      }

      return {
        ...state,
        [meta.feeTypeId]: getMergedFeeTypeWithOverride(existingFeeType, payload),
      };
    }

    case FEE_TYPES_ACTION_TYPE.DELETE_OVERRIDE: {
      const existingFeeType = state[meta.feeTypeId];

      if (!existingFeeType) {
        return state;
      }

      return {
        ...state,
        [meta.feeTypeId]: {
          ...existingFeeType,
          hasLocalOverride: false,
          localOverride: null,
        },
      };
    }

    default:
      return state;
  }
};

export default feeTypesReducer;
